import React, { useState } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import {
  Button,
  Select,
  Table,
  Column,
  PageBar,
  Switch,
  Dialog,
  FormGroup,
  Icon,
  AutoComplete,
  PopOver,
  OverlayTrigger,
  RadioGroup,
  Radio,
} from '@tencent/spaui';
import ABulkMiniDialog from '../businessSetting/ABulkMiniDialog';

import { RPCFactory } from '../../../utils/RequestUtil';

import { store } from '../../../store/Store';
import { GlobalStateAction } from '../../../actions/GlobalStateAction';
import { EmployeeFrozenStatus } from '../../../consts/EmployeeFrozenStatus';
import EmployeeDetailPresentationalComponent from './EmployeeDetailComponent';
import Role from '../../../consts/Role';
import WechatNotice from '../../common/wechatNotice';

const pageSizeList = [5, 10, 20];

const NumberInputer = (props) => {
  const [number, setNumber] = useState(props.value || 0);

  const handleCallback = (n) => {
    if (typeof props.onChange !== 'function') return;
    props.onChange(n);
  };

  const handleNumberChange = ({ target }) => {
    const { value } = target;
    if (!/^\d+$/.test(value)) return;
    const formated = Number(value.replace(/^0/, '')).toString();
    setNumber(formated);
    handleCallback(formated);
  };

  const handleAdd = () => {
    setNumber((n) => {
      const r = 1 + Number(n);
      handleCallback(r);
      return r;
    });
  };

  const handleSub = () => {
    setNumber((n) => {
      const r = Math.max(0, Number(n) - 1);
      handleCallback(r);
      return r;
    });
  };

  return (
    <div className="number-inputer">
      <div>
        <input value={number} onChange={handleNumberChange} />
      </div>
      <div className="number-operators">
        <div className="number-add" onClick={handleAdd}></div>
        <div className="number-sub" onClick={handleSub}></div>
      </div>
    </div>
  );
};

// 编辑接收上限的弹窗
const editReceiveLimit = (data, cb = (() => {})) => {
  const anchor = document.createElement('div');

  const close = () => {
    unmountComponentAtNode(anchor);
  };

  const Poper = () => {
    const [limit, setLimit] = useState(data.leadsReceiveUpperLimit || 0);
    const [type, setType] = useState(typeof data.leadsReceiveUpperLimit === 'number' ? 'limit' : 'null');

    const handleSubmit = () => {
      const newLimit = type === 'null' ? null : Number(limit);
      RPCFactory.employeeManage.updateLeadsReceiveLimit(data.userId, newLimit)
        .done(() => {
          close();
          cb(data.userId, newLimit);
        })
        .fail((ret, msg) => {
          window.alert(msg);
        });
    };

    const handleTypeChange = (_, value) => {
      if (value === 'null') {
        setType('null');
      } else {
        setType('limit');
      }
    };

    const handleLimitChange = (value) => {
      setLimit(value);
    };

    return (
      <Dialog
        show
        hideHeader
        style={{ width: 385 }}
        onCancel={close}
        onSubmit={handleSubmit}
        portalClassName="receive-limit-anchor-poper"
      >
        <div className="poper-fake-header">线索接收上限</div>
        <div className="poper-body">
          <div className="limit-edit-item">
            <Radio value="null" checked={type === 'null'} onChange={handleTypeChange}>
              不限
            </Radio>
          </div>
          <div className="limit-edit-item">
            <Radio value={limit} checked={type !== 'null'} onChange={handleTypeChange}>
              设置单日接收数量上限
              &nbsp;
              <NumberInputer value={limit} onChange={handleLimitChange} />
              &nbsp;
              条
            </Radio>
          </div>
        </div>
        <div style={{ height: 37 }} />
      </Dialog>
    );
  };
  render(<Poper />, anchor);
};

const DeleteMode = {
  distributeToOtherOwner: 1,
  distributeToPool: 2,
  deleteDirect: 3,
  needAskUser: 4,
  doNotAllowDeleteBecauseIsRuleSingleReceiver: 5,
};
export default class EmployeeManagePage extends React.Component {
  componentDidMount() {
    this.onSearchEmployee();
    this.getPasswordInfo();
    this.setState({ showWechatNotice: true });
    this.getQRCode();
    this.getOwnerIds();
    this.getSimpleGroupList();
  }

  constructor(props) {
    super(props);

    this.searchItems = [
      { value: 'name', label: '姓名' },
      { value: 'tel', label: '电话' },
      { value: 'qq', label: 'QQ' },
      { value: 'wxId', label: '微信号' },
      { value: 'userGroupName', label: '所属团队' },
    ];

    this.state = {
      searchItemKey: '',
      searchItemValue: '',
      pageSize: 10,
      pageIndex: 1,
      statusMap: {}, // 列表中员工的启用状态， 员工ID =》 状态
      employeeDetailShow: false,
      showDeleteEmployee: false,
      showWechatNotice: false,
      showDeleteSuccess: false,
      showDistributeToOthers: false,
      distributeOwnerId: '',
      distributeOwnerSearchValue: '',
      distributeOwnerList: [],
      isCodeDialogVisible: false,
      updateLeadsReceiveStatus: {
        show: false,
        userId: 0,
        leadsReceiveStatus: -1,
      },
      deleteMode: DeleteMode.deleteDirect,
      editUserId: '',
      editDialogShow: false,
      updateEmployeeStatus: {
        show: false,
        userId: 0,
        employeeStatus: 0,
      },
      groupList: [],
    };
  }
  onCodeDialogCancel = () => {
    this.setState({
      isCodeDialogVisible: false,
    });
  };

  getSimpleGroupList = () => {
    RPCFactory.employeeManage
    .getSimpleGroupList()
    .done((data) => {
      this.setState({ groupList: data.list });
    })
    .fail((ret, msg) => {
      window.alert(`获取团队列表错误：${msg}`);
    });
  }
  getPasswordInfo = () => {
    RPCFactory.account.getPasswordInfo().done((data) => {
      const psw = {
        isSet: !!data.mobile,
        mobile: data.mobile,
      };
      this.setState({ psw });
    });
  };

  getQRCode = () => {
    RPCFactory.accountSettings.createQRCode().done((data) => {
      this.setState({ codeUrl: data.qrCodeUrl });
    });
  };
  onChangeSearchItem = (event, value) => {
    this.setState({ searchItemKey: value });
  };

  onClearSearchItem = (event) => {
    this.setState({ searchItemKey: '', searchItemValue: '' });
    setTimeout(() => {
      this.onSearchEmployeeFirstPage();
    }, 0);
  };

  onChangeSearchItemValue = (event, value) => {
    this.setState({ searchItemValue: value });
  };
  onKeyPressHandler = (event, value) => {
    if (event.key == 'Enter') {
      this.onSearchEmployeeFirstPage();
    }
  };

  getSearchParameter = () => {
    let name;
    let tel;
    let qq;
    let wxId;
    let userGroupName;
    if (this.state.searchItemKey == 'name') {
      name = this.state.searchItemValue;
    } else if (this.state.searchItemKey == 'tel') {
      tel = this.state.searchItemValue;
    } else if (this.state.searchItemKey == 'qq') {
      qq = this.state.searchItemValue;
    } else if (this.state.searchItemKey == 'wxId') {
      wxId = this.state.searchItemValue;
    } else if (this.state.searchItemKey == 'userGroupName') {
      userGroupName = this.state.searchItemValue;
    }
    const { pageSize, pageIndex } = this.state;
    return { name, tel, qq, wxId, userGroupName, pageSize, pageIndex };
  };

  /**
   * 点击查询按钮
   * @param event
   */
  onSearchEmployee = (event) => {
    const param = this.getSearchParameter();
    this.query(param.name, param.tel, param.qq, param.wxId, param.userGroupName, param.pageSize, param.pageIndex);
  };

  /**
   * 点击查询按钮
   * @param event
   */
  onSearchEmployeeFirstPage = (event) => {
    const param = this.getSearchParameter();
    this.setState({ pageIndex: 1 });
    this.query(param.name, param.tel, param.qq, param.wxId, param.userGroupName, param.pageSize, 1);
  };

  /**
   * 筛选条件进行后台请求，查询员工
   * @param name  姓名
   * @param tel  电话
   * @param qq  QQ
   * @param pageSize  每页数量
   * @param pageIndex  页码
   */
  query = (name, tel, qq, wxId, userGroupName, pageSize, pageIndex) => {
    store.dispatch({ type: GlobalStateAction.SHOW_LOADING });
    RPCFactory.employeeManage
      .getEmployees(name, qq, tel, userGroupName, pageSize, pageIndex, undefined, wxId)
      .done((data) => {
        this.setState({
          data: data.entities,
          totalSize: data.size,
        });

        if (data.entities) {
          data.entities.forEach((e) => {
            this.setState({
              [e.userId]: e.status,
            });
            const key = `receivestatus_${e.userId}`;
            this.setState({
              [key]: e.leadsReceiveStatus,
            });
          });
        }
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
      })
      .fail((ret, msg) => {
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
        window.alert(`获取员工列表失败，错误信息：${msg}`);
      });
  };

  /**
   * 页码点击
   * @param event
   * @param value
   */
  onChangePageIndex = (event, value) => {
    this.setState({ pageIndex: value });
    const param = this.getSearchParameter();
    param.pageIndex = value;
    this.query(param.name, param.tel, param.qq, param.wxId, param.userGroupName, param.pageSize, param.pageIndex);
  };

  /**
   * 页面条目数量点击
   * @param event
   * @param value
   */
  onChangePageSize = (event, value) => {
    this.setState({ pageSize: value });
    const param = this.getSearchParameter();
    param.pageSize = value;
    this.query(param.name, param.tel, param.qq, param.wxId, param.userGroupName, param.pageSize, param.pageIndex);
  };

  // 处理员工状态修改 登录改为冻结 更新state以使弹框出现
  logInStatusChange = (userId) => {
    this.setState({ updateEmployeeStatus: { show: true, userId } });
  };

  // 处理员工状态修改弹框的取消/关闭按钮
  handleEmployeeStatusChangeClose = () => {
    this.setState({ updateEmployeeStatus: { show: false } });
  };

  // 处理员工状态修改弹框-登录改为冻结-的提交按钮
  toggleEmployeeStatus = () => {
    const status = EmployeeFrozenStatus.FREEZE;
    store.dispatch({ type: GlobalStateAction.SHOW_LOADING });
    RPCFactory.employeeManage
      .updateEmployeeStatus(this.state.updateEmployeeStatus.userId, status)
      .done((data) => {
        this.setState({ [this.state.updateEmployeeStatus.userId]: status, updateEmployeeStatus: { show: false } });
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
      })
      .fail((ret, msg) => {
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
        window.alert(`修改失败，错误信息：${msg}`);
      });
  };

  // 处理员工接收线索状态修改 更新state以使弹框出现
  changeReceiveStatusOn = (userId, leadsReceiveStatus) => {
    this.setState({ updateLeadsReceiveStatus: { show: true, userId, leadsReceiveStatus } });
  };

  // 处理员工接收线索状态修改 接收选项值
  handleLeadsReceiveStatusSelect = (event, value) => {
    this.setState({
      updateLeadsReceiveStatus: {
        show: true,
        userId: this.state.updateLeadsReceiveStatus.userId,
        leadsReceiveStatus: value,
      },
    });
  };

  // 处理员工接收线索状态修改弹框的取消按钮
  handleReceiveStatusChangeClose = () => {
    this.setState({ updateLeadsReceiveStatus: { show: false } });
  };

  // 离线更新接收数量
  updateReceiveData = (userId, limits) => {
    const _data = JSON.parse(JSON.stringify(this.state.data));
    for (const item of _data) {
      if (item.userId !== userId) continue;
      item.leadsReceiveUpperLimit = limits;
      break;
    }
    this.setState({ data: _data });
  };

  // 处理员工接收线索状态修改的确定按钮
  toggleLeadsReceiveStatus = () => {
    store.dispatch({ type: GlobalStateAction.SHOW_LOADING });
    RPCFactory.employeeManage
      .updateLeadsReceiveStatus(
        this.state.updateLeadsReceiveStatus.userId,
        this.state.updateLeadsReceiveStatus.leadsReceiveStatus,
      )
      .done(() => {
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
        // this.onSearchEmployee();
        this.onSearchEmployeeFirstPage();
        this.setState({ updateLeadsReceiveStatus: { show: false } });
      })
      .fail((ret, msg) => {
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
        window.alert(`修改失败，错误信息：${msg}`);
      });
  };

  /**
   * 姓名列，隐藏用户Id
   * @param type
   * @param name
   * @param value
   * @param data
   * @returns {*}
   */
  renderName = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }

    return (
      <div>
        {value}
        <div style={{ display: 'none' }}>{data.userId}</div>
      </div>
    );
  };

  renderRole = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }
    const key = Object.keys(Role).find((key) => value === Role[key].code);
    return Role[key].desc;
  };

  /**
   * 开启状态列
   * @param type
   * @param name
   * @param value
   * @param data
   * @returns {*}
   */
  renderStatus = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }

    const checked = this.state[data.userId] == EmployeeFrozenStatus.NORMAL;

    let statusSwtich;
    const canEditEmployee = window.pageProps.privileges.includes(PrivilegeCode.EMPLOYEE_ADD_UPDATE.getCode());
    if (canEditEmployee) {
      statusSwtich = (
        <Switch
          checked={checked}
          onChange={(event, afterChecked) => {
            if (afterChecked == true) {
              const status = EmployeeFrozenStatus.NORMAL;
              const { userId } = data;
              store.dispatch({ type: GlobalStateAction.SHOW_LOADING });
              RPCFactory.employeeManage
                .updateEmployeeStatus(data.userId, status)
                .done((data) => {
                  this.setState({ [userId]: status, updateEmployeeStatus: { show: false, userId } });
                  store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
                })
                .fail((ret, msg) => {
                  store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
                  window.alert(`修改失败，错误信息：${msg}`);
                });
            } else {
              this.logInStatusChange(data.userId);
            }
          }}
        ></Switch>
      );
    }

    return (
      <div>
        {statusSwtich}
        {checked ? (
          <span style={{ 'margin-right': '5px' }}>开启</span>
        ) : (
          <span style={{ 'margin-right': '5px' }}>关闭</span>
        )}
      </div>
    );
  };

  /**
   * 线索接收状态列
   * @param type
   * @param name
   * @param value
   * @param data
   * @returns {*}
   */
  renderLeadsReceiveStatus = (type, name, value, data) => {
    const popoverstyle = {
      maxWidth: '550px',
    };
    const tips = '开启后，表示新线索进入时，线索可分配至当前员工；关闭后，表示新线索进入时，暂停线索分配至该员工';

    const popover = (
      <PopOver style={popoverstyle}>
        <div className="poptable">{tips}</div>
      </PopOver>
    );
    if (type == 'head') {
      return (
        <span>
          {value}
          <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
            <i className="icon icon-help">
              <i></i>
            </i>
          </OverlayTrigger>
        </span>
      );
    }

    const key = `receivestatus_${data.userId}`;
    const checked = this.state[key] == 1;
    const checked2 = this.state[data.userId] == EmployeeFrozenStatus.NORMAL;

    let statusSwtich;
    const canEditEmployee = window.pageProps.privileges.includes(PrivilegeCode.EMPLOYEE_ADD_UPDATE.getCode());
    if (canEditEmployee) {
      statusSwtich = (
        <i
          style={{ visibility: 'visible' }}
          onClick={(e) => this.changeReceiveStatusOn(data.userId, data.leadsReceiveStatus)}
          className="icon icon-pen"
        ></i>
      );
    }

    return (
      <div>
        {checked && checked2 ? (
          <span style={{ 'margin-right': '5px' }}>接收</span>
        ) : (
          <span style={{ 'margin-right': '5px' }}>暂停</span>
        )}
        {checked2 ? statusSwtich : ''}
      </div>
    );
  };

  // 线索接收上限
  renderLeadsReceiveLimit = (type, name, value, data) => {
    if (type == 'head') {
      const popoverstyle = { maxWidth: '400px' };
      const tips = '针对客服人员，可为其设置单日可接收线索数量上限。新增员工时默认写入：不限。';
      const popover = (
        <PopOver style={popoverstyle}>
          <div className="poptable">{tips}</div>
        </PopOver>
      );
      return (
        <span>
          {value}
          <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
            <i className="icon icon-help">
              <i></i>
            </i>
          </OverlayTrigger>
        </span>
      );
    }

    let limit = data.leadsReceiveUpperLimit;
    // 只能修改客服人员的这个数据
    const canEdit = data.role === Role.OPERATOR_ROLE_LEADS_CEMPLOYEE.getCode();
    if (typeof limit !== 'number' || !canEdit) limit = '不限';

    return (
      <div className="receive-limits" style={{ display: 'flex', alignItems: 'center' }}>
        <span>{ limit }</span>
        {
          canEdit && (
            <div onClick={() => editReceiveLimit(data, this.updateReceiveData)}
              className="edit-tag svg-icon-edit-with-pen"
            />
          )
        }
      </div>
    );
  };

  renderOperate = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }

    if (data.isSystemRole) {
      return (
        <div>
          <a
            href={'javascript:;'}
            onClick={(e) => {
              this.setState({ editUserId: data.userId, editDialogShow: true });
            }}
          >
            编辑
          </a>
        </div>
      );
    }
    return (
      <div>
        <a
          href={'javascript:;'}
          onClick={(e) => {
            this.setState({ editUserId: data.userId, editDialogShow: true });
          }}
        >
          编辑
        </a>
        <a
          href={'javascript:;'}
          onClick={(e) => {
            this.deleteEmployee(data.userId);
          }}
        >
          删除
        </a>
      </div>
    );
  };

  deleteEmployee = (userId) => {
    this.userEmployeeIdForDelete = userId;
    RPCFactory.employeeManage.employeeInDistributeRule(userId)
      .done((data) => {
        if (data) {
          this.setState({
            deleteMode: DeleteMode.doNotAllowDeleteBecauseIsRuleSingleReceiver,
            showDeleteEmployee: true,
          });
        } else {
          RPCFactory.employeeManage.checkChatsExist(userId)
            .done((data) => {
              if(data) {
                this.setState({ deleteMode: DeleteMode.distributeToOtherOwner });
                this.setState({ showDeleteEmployee: true });
              } else {
                RPCFactory.leadsManage.getLeadsCount([userId])
                  .done((data) => {
                    if (data) {
                      this.setState({
                        deleteMode: DeleteMode.needAskUser,
                      });
                    } else {
                      this.setState({ deleteMode: DeleteMode.deleteDirect });
                    }
                    this.setState({ showDeleteEmployee: true });
                  })
                  .fail((code, msg) => {
                    window.alert(`接口失败，错误信息：${msg}`);
                    this.props.onCancel();
                  });
              }
            })
            .fail((code, msg) => {
              window.alert(`获取会话接口失败，错误信息：${msg}`);
              this.props.onCancel();
            });
        }
      })
      .fail((code, msg) => {
        window.alert(`接口失败，错误信息：${msg}`);
        this.props.onCancel();
      });
  }

  handleCloseDeleteEmployee = () => {
    this.setState({
      showDeleteEmployee: false,
    });
  }
  handleCloseDeleteSuccess() {
    this.setState({
      showDeleteSuccess: false,
    });
  }
  handleConfirmDeleteEmployee(leadsTransferStrategy, targetUserId) {
    this.handleCloseDeleteEmployee();
    // 有会话线索，则显示转移dialog, 没有会话有线索，则显示转公海池转归属人dialog, 没有会话没有线索,直接删除
    RPCFactory.employeeManage
      .deleteEmployee(this.userEmployeeIdForDelete, leadsTransferStrategy, targetUserId)
      .done((data) => {
        this.setState({
          showDeleteSuccess: true,
        });
        this.onSearchEmployeeFirstPage();
      })
      .fail((code, msg) => {
        window.alert(`删除员工失败，${msg}`);
        this.props.onCancel();
      });
  }

  showCodeDialog = (show = true) => {
    this.setState({ isCodeDialogVisible: show });
  };

  /**
   * 编辑员工确认
   * @param event
   */

  onEmployeeConfirm = (userId, name, loginType, qq, wxId, role, tel, userGroupId, dataRange, onComplete) => {
    store.dispatch({
      type: GlobalStateAction.ADD_EDIT_EMPLOYEE,
      payload: {
        groupList: [],
      },
    });
    if (userId) {
      RPCFactory.employeeManage
        .updateEmployee(userId, name, role, tel, userGroupId, dataRange)
        .done((data) => {
          this.onEmployeeCancel();
          this.onSearchEmployee();
          if (onComplete) {
            onComplete();
            if (loginType == 2) {
              this.showCodeDialog();
            }
          }
        })
        .fail((ret, msg) => {
          window.alert(`更新员工信息失败，错误信息：${msg}`);
          if (onComplete) {
            onComplete();
          }
        });
    } else {
      RPCFactory.employeeManage
        .insertEmployee(name, loginType, qq, wxId, role, tel, userGroupId, dataRange)
        .done((data) => {
          this.onEmployeeCancel();
          this.onSearchEmployeeFirstPage();
          if (onComplete) {
            onComplete();
            if (loginType == 2) {
              this.showCodeDialog();
            }
          }
        })
        .fail((ret, msg) => {
          window.alert(`插入员工信息失败，错误信息：${msg}`);
          if (onComplete) {
            onComplete();
          }
        });
    }
  };

  onEmployeeCancel = () => {
    this.setState({ editDialogShow: false });
  };

  getOwnerIds() {
    RPCFactory.employeeManage
      .getEmployees(undefined, undefined, undefined, undefined, undefined, undefined, 0)
      .done((data) => {
        const leadsOwner = [];
        (data.entities || []).forEach((employee) => {
          // var mark = employee.status == EmployeeFrozenStatus.NORMAL ? "有效" : "封停";
          if (employee.status === 0 && employee.leadsReceiveStatus !== 0) {
            leadsOwner.push({ value: employee.userId, label: `${employee.name} - ${employee.userGroupName}` });
          }
        });
        this.setState({ distributeOwnerList: leadsOwner });
      });
  }
  closeDistributeToOthersDialog = () => {
    this.setState({ showDistributeToOthers: false });
  }

  handleDistributeOwnerChange = (event, distributeOwnerId) => {
    this.setState({
      distributeOwnerId,
    });
  }

  handleDistributeOwnerSearch = (event, value) => {
    this.setState({
      distributeOwnerSearchValue: value,
    });
  }

  showDistributeToOthersDialog = () => {
    this.handleCloseDeleteEmployee();
    this.setState({ showDistributeToOthers: true });
  }

  confirmDeleteAndDistributeToPool = () => {
    this.handleCloseDeleteEmployee();
    this.handleConfirmDeleteEmployee(1);
  }

  confirmDeleteAndDistributeToOthers = () => {
    this.setState({ showDistributeToOthers: false });
    this.handleConfirmDeleteEmployee(2, this.state.distributeOwnerId);
  }

  confirmDeleteAndDistributeDirect = () => {
    this.handleCloseDeleteEmployee();
    this.handleConfirmDeleteEmployee();
  }

  render() {
    const canAddEmployee = window.pageProps.privileges.includes(PrivilegeCode.EMPLOYEE_ADD_UPDATE.getCode());
    const canEditEmployee = window.pageProps.privileges.includes(PrivilegeCode.EMPLOYEE_ADD_UPDATE.getCode());
    const leadsReceiveStatusEnum = [
      {
        value: 1,
        children: '接收',
      },
      {
        value: 0,
        children: '暂停',
      },
    ];

    return (
      <div className="main">
        {this.state.showWechatNotice && <WechatNotice />}
        <EmployeeDetailPresentationalComponent
          onConfirm={this.onEmployeeConfirm}
          onCancel={this.onEmployeeCancel}
          showCodeDialog={this.showCodeDialog}
          userId={this.state.editUserId}
          show={this.state.editDialogShow}
          groupList={this.state.groupList}
        />
        <Dialog
          type="simple"
          cancelButton={false}
          onSubmit={this.onCodeDialogCancel}
          show={this.state.isCodeDialogVisible}
          onClose={this.onCodeDialogCancel.bind(this)}
          submitLabel="知道了"
          style={{ width: '480px' }}
          headerStyle={{ padding: '0', margin: '0', height: '50' }}
          footerStyle={{ 'text-align': 'center' }}
        >
          复制二维码并发送给员工，让其扫码绑定公众号，员工即可收到线索到达和分配的消息提醒
          <div className="QRcode" style={{ 'margin-left': '35%' }}>
            <img className="QRcode-img" src={this.state.codeUrl} alt="" style={{ width: '120px' }} />
          </div>
        </Dialog>
        <Dialog
          show={this.state.showDeleteSuccess}
          time={2000}
          timeCallback={this.handleCloseDeleteSuccess.bind(this)}
          type="tip"
          iconType="success"
        >
          删除员工成功!
        </Dialog>
        <Dialog
          style={{ width: '384px' }}
          type="normal"
          className="spaui-dialog-confirm-normal"
          title="确认是否删除员工？"
          iconType="tip"
          show={this.state.showDeleteEmployee}
          cancelLabel='知道了'
          cancelButton={this.state.deleteMode === DeleteMode.doNotAllowDeleteBecauseIsRuleSingleReceiver}
          submitButton={false}
          onClose={this.handleCloseDeleteEmployee}
          // onSubmit={this.handleConfirmDeleteEmployee.bind(this)}
          onCancel={this.handleCloseDeleteEmployee}
        >
          {this.state.deleteMode === DeleteMode.doNotAllowDeleteBecauseIsRuleSingleReceiver && (
            <div>该员工是当前生效的线索分配规则中的唯一可分配员工，请先更改线索分配规则，才可删除该员工。</div>
          )}
          {this.state.deleteMode !== DeleteMode.doNotAllowDeleteBecauseIsRuleSingleReceiver && (
            <div>删除后不可恢复且线索将无法再分配至该员工。
              {this.state.deleteMode === DeleteMode.needAskUser && (
                <div className='delete-buttons'>
                  <Button displayType='primary' onClick={this.confirmDeleteAndDistributeToPool}>确认删除，该员工的线索释放公海池</Button>
                  <Button displayType='default' onClick={this.showDistributeToOthersDialog}>确认删除，该员工的线索重新分配</Button>
                  <Button displayType='default' onClick={this.handleCloseDeleteEmployee}>取消</Button>
                </div>
              )}
              {this.state.deleteMode === DeleteMode.distributeToOtherOwner && (
                <div className='delete-buttons'>
                <Button displayType='primary' onClick={this.showDistributeToOthersDialog}>确认删除，该员工的线索重新分配</Button>
                <Button displayType='default' onClick={this.handleCloseDeleteEmployee}>取消</Button>
                </div>
              )}
              {this.state.deleteMode === DeleteMode.deleteDirect && (
                <div className='delete-buttons direct'>
                  <Button displayType='primary' onClick={this.confirmDeleteAndDistributeDirect}>确认</Button>
                <Button displayType='default' onClick={this.handleCloseDeleteEmployee}>取消</Button>
                </div>
              )}
            </div>
          )}
        </Dialog>
        <Dialog
          style={{ width: '414px' }}
          type="normal"
          className="spaui-dialog-distrubute"
          show={this.state.showDistributeToOthers}
          onSubmit={this.confirmDeleteAndDistributeToOthers}
          onCancel={this.closeDistributeToOthersDialog}
          onClose={this.closeDistributeToOthersDialog}
        >
          <div>删除后不可恢复且线索将无法再分配至该员工。
            {this.state.deleteMode === DeleteMode.needAskUser && (
              <div className='delete-buttons'>
                <Button displayType='primary' onClick={this.confirmDeleteAndDistributeToPool}>确认删除，该员工的线索释放公海池</Button>
                <Button displayType='default' onClick={this.showDistributeToOthersDialog}>确认删除，该员工的线索重新分配</Button>
                <Button displayType='default' onClick={this.handleCloseDeleteEmployee}>取消</Button>
              </div>
            )}
            {this.state.deleteMode === DeleteMode.distributeToOtherOwner && (
              <div className='delete-buttons'>
              <Button displayType='primary' onClick={this.showDistributeToOthersDialog}>确认删除，该员工的线索重新分配</Button>
              <Button displayType='default' onClick={this.handleCloseDeleteEmployee}>取消</Button>
              </div>
            )}
            {this.state.deleteMode === DeleteMode.deleteDirect && (
              <div className='delete-buttons direct'>
                <Button displayType='primary' onClick={this.confirmDeleteAndDistributeDirect}>确认</Button>
              <Button displayType='default' onClick={this.handleCloseDeleteEmployee}>取消</Button>
              </div>
            )}
          </div>
        </Dialog>
        <Dialog
          style={{ width: '414px' }}
          type="normal"
          className="spaui-dialog-distrubute"
          show={this.state.showDistributeToOthers}
          onSubmit={this.confirmDeleteAndDistributeToOthers}
          onCancel={this.closeDistributeToOthersDialog}
          onClose={this.closeDistributeToOthersDialog}
        >
          <div className='distribute-box'>
            <span className='text'>将该员工线索转移给</span>
            <Select
              html
              search
              placeholder="输入员工姓名进行搜索"
              data={this.state.distributeOwnerList}
              searchValue={this.state.distributeOwnerSearchValue}
              value={this.state.distributeOwnerId}
              onChange={this.handleDistributeOwnerChange}
              onSearch={this.handleDistributeOwnerSearch}
              status={this.state.distributeOwnerId === '' ? 'has-error' : ''}
            />
          </div>
        </Dialog>

        <Dialog
          style={{ width: '384px' }}
          type="normal"
          className="spaui-dialog-confirm-normal"
          title="确定关闭员工登录状态？"
          show={this.state.updateEmployeeStatus.show}
          onClose={this.handleEmployeeStatusChangeClose.bind(this)}
          onSubmit={this.toggleEmployeeStatus.bind(this)}
          onCancel={this.handleEmployeeStatusChangeClose.bind(this)}
        >
          <div>
            <p align={'left'}>关闭员工登录状态后，线索接收状态也会自动暂停，线索将无法分配至该员工。</p>
          </div>
        </Dialog>
        <ABulkMiniDialog
          width={'306px'}
          show={this.state.updateLeadsReceiveStatus.show}
          onSubmit={this.toggleLeadsReceiveStatus.bind(this)}
          onCancel={this.handleReceiveStatusChangeClose.bind(this)}
        >
          <div className="lead-radios">
            <div className="titlebar modal-titlebar">
              <h4 className="title">修改线索接收状态</h4>
            </div>
            <FormGroup>
              <RadioGroup
                data={leadsReceiveStatusEnum}
                value={this.state.updateLeadsReceiveStatus.leadsReceiveStatus}
                onChange={this.handleLeadsReceiveStatusSelect.bind(this)}
                className="spaui-radios"
              />
            </FormGroup>
          </div>
        </ABulkMiniDialog>

        <div className="card">
          <div className="datarea">
            <div className="toolbars">
              <div className="toolbar table-toolbar">
                <div className="toolbar-left">
                  <Button
                    onClick={(e) => {
                      if (canAddEmployee) {
                        this.setState({ editUserId: '', editDialogShow: true });
                      }
                    }}
                    displayType="primary"
                  >
                    <Icon type="add" />
                    添加员工
                  </Button>
                </div>
                <div className="toolbar-right">
                  <Select
                    data={this.searchItems}
                    value={this.state.searchItemKey}
                    onChange={this.onChangeSearchItem}
                    clearable
                  />
                  <AutoComplete
                    value={this.state.searchItemValue}
                    onKeyPress={this.onKeyPressHandler}
                    onChange={this.onChangeSearchItemValue}
                    onClickSearchIcon={this.onSearchEmployeeFirstPage}
                    onClear={this.onClearSearchItem}
                  />
                </div>
              </div>
            </div>
            <div className="datalist">
              <Table data={this.state.data} onColumnWidthChange={this.handleColumnWidthChange}>
                <Column name="status" render={this.renderStatus}>
                  登录状态
                </Column>
                <Column name="name" render={this.renderName}>
                  姓名
                </Column>
                <Column name="qq">QQ号码</Column>
                <Column name="wxId">微信号码</Column>
                <Column name="tel">电话号码</Column>
                <Column name="role" render={this.renderRole}>
                  角色
                </Column>
                <Column name="leadsReceiveStatus" render={this.renderLeadsReceiveStatus}>
                  线索接收状态
                </Column>
                <Column name="leadsReceiveStatus" render={this.renderLeadsReceiveLimit}>
                  线索接收上限
                </Column>
                <Column name="userGroupName">所属团队</Column>
                <Column show={canEditEmployee} name="operate" render={canEditEmployee ? this.renderOperate : ''}>
                  操作
                </Column>
              </Table>
            </div>
            <PageBar
              value={this.state.pageIndex}
              pageSize={this.state.pageSize}
              totalSize={this.state.totalSize}
              pageSizeList={pageSizeList}
              onChange={this.onChangePageIndex}
              onPageSizeChange={this.onChangePageSize}
            />
          </div>
        </div>
      </div>
    );
  }
}
